import { FocusSDK as focusSDK, isFocusEnv, currentIsProd } from "@/utils";
import { NetType } from "@/components/Modals/ChangeNetModal";
import { handleException } from "./handleErrors";

let dsn = "https://6461eef6617f4acba84d59c3cd3089bf@infosum-api.jzb.beijing.gov.cn/5";
let netType = focusSDK?.isPrivateNet() ? "private" : "public";
if (focusSDK?.getCurrentNetType() === NetType.PRIVATE_NET) {
  dsn = "https://6461eef6617f4acba84d59c3cd3089bf@infosum-api.jzb.beijing.egov.cn/5";
}

export enum ReportLevel {
  DEFAULT = 0, // 全开
  INFO = 1, // 上报info
  WARN = 2, // 上报warn
  ERROR = 3, // 上报error
  CLOSE = 4 // 全关
}

let globalSendLevel = ReportLevel.DEFAULT;

export const setGlobalSentrySendLevel = (state: ReportLevel) => {
  globalSendLevel = state;
};

export const getGlobalSentrySendLevel = () => {
  const allLevels = ["log", "debug", "info", "warning", "error"];
  switch (globalSendLevel) {
    case ReportLevel.DEFAULT:
      return allLevels;
    case ReportLevel.INFO:
      return ["info", "warning", "error"];
    case ReportLevel.WARN:
      return ["warning", "error"];
    case ReportLevel.ERROR:
      return ["error"];
    case ReportLevel.CLOSE:
      return [];
    default:
      return allLevels;
  }
};

function initSentry() {
  try {
    // Sentry.init({
    //   dsn,
    //   autoSessionTracking: true,
    //   integrations: [new Integrations.BrowserTracing()],
    //   // We recommend adjusting this value in production, or using tracesSampler
    //   // for finer control
    //   tracesSampleRate: 1,
    //   beforeSend: (event, hint) => {
    //     const levels = getGlobalSentrySendLevel();
    //     if (globalSendLevel !== ReportLevel.DEFAULT) {
    //       if (!levels.includes(event?.level || "info")) {
    //         return null;
    //       }
    //     }
    //     const exceptArr = event?.exception?.values || [];
    //     if (exceptArr.length) {
    //       try {
    //         const tag = handleException(exceptArr);
    //         if (tag) {
    //           return event;
    //         } else {
    //           return null;
    //         }
    //       } catch (e) {
    //         return event;
    //       }
    //     }
    //     return event;
    //   }
    // });
    // Sentry.configureScope(function (scope) {
    //   scope.setTag("custom-container", isFocusEnv() ? "electron" : "web");
    //   scope.setTag("custom-net", netType);
    // });
  } catch (e) {
    console.error(e);
  }
}

export default initSentry;
